"use client";

import React from "react";
import { Facebook, Instagram, Twitter, Linkedin, Mail, Phone, MapPin } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { Separator } from "@/components/ui/separator";
import { MenuProvider, useMenu } from "@/integrations/wordpress/WordPressMenuProvider";
import { NavigationMenu, NavigationMenuItem, NavigationMenuLink, NavigationMenuList } from "@/components/ui/navigation-menu";
function FooterMenuConsumer({
  title
}: {
  title: string;
}) {
  const {
    menuItems,
    loading
  } = useMenu();
  return <div className="flex flex-col gap-6">
      <h3 className="font-default text-lg font-semibold text-foreground tracking-wide">
        {title}
      </h3>
      
      {loading ? <div className="flex flex-col gap-3">
          {[1, 2, 3, 4].map((_, i) => <div key={i} data-index={i} className="h-5 w-24 bg-muted animate-pulse rounded-md" />)}
        </div> : <NavigationMenu viewport={false} className="block w-full max-w-none z-10">
          <NavigationMenuList className="flex-col items-start gap-3 space-x-0">
            {menuItems.map((item, i) => <NavigationMenuItem key={item.id} className="w-full" data-index={i}>
                <NavigationMenuLink asChild className="w-full justify-start px-0 py-1 h-auto text-muted-foreground hover:text-primary hover:bg-transparent data-[active=true]:bg-transparent transition-colors duration-300">
                  <Link to={item.href || "#"}>{item.label}</Link>
                </NavigationMenuLink>
              </NavigationMenuItem>)}
          </NavigationMenuList>
        </NavigationMenu>}
    </div>;
}
export default function FooterBikeLux() {
  const currentYear = new Date().getFullYear();
  const socialLinks = [{
    icon: Facebook,
    href: "#",
    label: "Facebook"
  }, {
    icon: Instagram,
    href: "#",
    label: "Instagram"
  }, {
    icon: Twitter,
    href: "#",
    label: "Twitter"
  }, {
    icon: Linkedin,
    href: "#",
    label: "LinkedIn"
  }];
  return <section id="footer-bikelux" className="bg-background text-foreground pt-20 pb-8 border-t border-border relative overflow-hidden">
      {}
      <div className="absolute top-0 left-1/2 -translate-x-1/2 w-[800px] h-[400px] bg-primary/5 blur-[120px] rounded-full pointer-events-none" aria-hidden="true" />

      <div className="container mx-auto px-6 md:px-12 relative z-10">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-12 gap-12 lg:gap-8 mb-16">
          
          {}
          <div className="lg:col-span-4 flex flex-col gap-6">
            <Link to="/" className="inline-block w-max">
              <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1638728/img/ormarent_logo_footer.png" alt="Orma Rent" className="h-7 w-auto object-contain" />
            </Link>
            <p className="text-muted-foreground leading-relaxed max-w-sm">Orma Rent è una piattaforma di e‑commerce dedicata alla vendita e al noleggio di biciclette e‑bike di alta qualità. Soluzioni ecologiche per gli spostamenti quotidiani con un'esperienza d'acquisto fluida.</p>
            <div className="flex flex-col gap-3 mt-2">
              <div className="flex items-center gap-3 text-muted-foreground">
                <MapPin className="size-4 text-primary" />
                <span className="text-sm">Sudomerska, 814/46 - Praha - CZ</span>
              </div>
              <div className="flex items-center gap-3 text-muted-foreground">
                <Phone className="size-4 text-primary" />
                <span className="text-sm">+420</span>
              </div>
              <div className="flex items-center gap-3 text-muted-foreground">
                <Mail className="size-4 text-primary" />
                <span className="text-sm">info@ormarent.com</span>
              </div>
            </div>
          </div>

          {}
          <div className="lg:col-span-2 lg:col-start-6">
            <MenuProvider menu_id="50">
              <FooterMenuConsumer title="Esplora" />
            </MenuProvider>
          </div>

          {}
          <div className="lg:col-span-2">
            <MenuProvider menu_id="51">
              <FooterMenuConsumer title="Servizi" />
            </MenuProvider>
          </div>

          {}
          <div className="lg:col-span-3 lg:col-start-10 flex flex-col gap-6">
            <h3 className="font-default text-lg font-semibold text-foreground tracking-wide">
              Connettiti
            </h3>
            <p className="text-sm text-muted-foreground">
              Seguici sui social per le ultime novità e consigli sui percorsi ciclistici.
            </p>
            <div className="flex flex-wrap gap-3 mt-2">
              {socialLinks.map((social, i) => {
              const Icon = social.icon;
              return <Button key={i} data-index={i} variant="outline" size="icon" asChild className="rounded-md border-border bg-transparent text-muted-foreground hover:bg-primary/10 hover:text-primary hover:border-primary hover:shadow-[0_0_15px_rgba(var(--color-primary),0.3)] transition-all duration-300">
                    <Link to={social.href} aria-label={social.label}>
                      <Icon className="size-4" />
                    </Link>
                  </Button>;
            })}
            </div>
          </div>

        </div>

        {}
        <Separator className="bg-border/60 mb-8" />
        
        <div className="flex flex-col md:flex-row justify-between items-center gap-4 text-sm text-muted-foreground">
          <p>
            © {currentYear} Orma Rent. Tutti i diritti riservati.
          </p>
          
          <div className="flex items-center h-5">
            <Link to="#" className="hover:text-primary transition-colors duration-200">
              Privacy Policy
            </Link>
            <Separator orientation="vertical" className="mx-4 bg-border/60" />
            <Link to="#" className="hover:text-primary transition-colors duration-200">
              Termini di Servizio
            </Link>
            <Separator orientation="vertical" className="mx-4 bg-border/60" />
            <Link to="#" className="hover:text-primary transition-colors duration-200">
              Cookie Policy
            </Link>
          </div>
        </div>
      </div>
    </section>;
}